import { createContext, useContext } from 'react';

export const AnalyticsViewContext = createContext({
  appliedStartDate: '',
  appliedEndDate: '',
  isSampleData: true
});

export const useAnalyticsViewContext = () => useContext(AnalyticsViewContext);
